export default __webpack_public_path__ + "static/buddha-logo-6431474dadfc30bf48f4f7a5a90c35c1.png";